export default "__VITE_ASSET__283d0668__"